import {
    LayoutDashboard, Users, IdCard, ShieldCheck, CalendarCheck2, CreditCard,
    Heart, Image, Tags, LayoutGrid, MessageSquare, Headset, Bell, BarChart3,
    CalendarClock, DatabaseBackup, Store, SlidersHorizontal, HelpCircle, NotebookPen, UserCog, KeyRound, LockKeyhole, Smartphone, Clock3, UserX, Flag, Video,
} from 'lucide-react';

// Single source of truth for admin navigation — both the Sidebar (grouped,
// collapsible) and the command palette (flat, searchable) read from this so
// adding/renaming a page only has to happen in one place.
export const NAV_GROUPS = [
    {
        id: 'access', label: 'Users & Access', Icon: Users, items: [
            { path: '/users', Icon: Users, label: 'Users' },
            { path: '/service-providers', Icon: Store, label: 'Service Providers' },
            { path: '/profiles', Icon: IdCard, label: 'Profiles' },
            { path: '/profile-reports', Icon: Flag, label: 'Profile Reports' },
            { path: '/incomplete-registrations', Icon: Clock3, label: 'Incomplete Profiles' },
            { path: '/deactivated-accounts', Icon: UserX, label: 'Deactivated Accounts' },
            { path: '/account-passwords', Icon: KeyRound, label: 'Account Passwords' },
            { path: '/password-vault', Icon: LockKeyhole, label: 'Password Vault' },
            { path: '/admin-access', Icon: ShieldCheck, label: 'Admin Access' },
        ],
    },
    {
        id: 'commerce', label: 'Bookings & Plans', Icon: CalendarCheck2, items: [
            { path: '/bookings', Icon: CalendarCheck2, label: 'Bookings' },
            { path: '/plans', Icon: CreditCard, label: 'Plans' },
            { path: '/plan-renewals', Icon: CalendarClock, label: 'Plan Renewals' },
        ],
    },
    {
        id: 'content', label: 'Content', Icon: Heart, items: [
            { path: '/testimonials', Icon: Heart, label: 'Success Stories' },
            { path: '/banners', Icon: Image, label: 'Banners' },
            { path: '/faqs', Icon: HelpCircle, label: 'FAQs' },
            { path: '/blogs', Icon: NotebookPen, label: 'Blog' },
            { path: '/service-categories', Icon: Tags, label: 'Service Categories' },
            { path: '/service-cards', Icon: LayoutGrid, label: 'Service Cards' },
        ],
    },
    {
        id: 'comms', label: 'Communication', Icon: MessageSquare, items: [
            { path: '/messages', Icon: MessageSquare, label: 'Messages' },
            { path: '/support-chat', Icon: Headset, label: 'Support Chat' },
            { path: '/notifications', Icon: Bell, label: 'Notifications' },
            { path: '/call-recordings', Icon: Video, label: 'Call Recordings' },
        ],
    },
    {
        id: 'insights', label: 'Insights', Icon: BarChart3, items: [
            { path: '/analytics', Icon: BarChart3, label: 'Analytics' },
        ],
    },
    {
        id: 'marketplace', label: 'Marketplace', Icon: Store, items: [
            { path: '/services', Icon: Store, label: 'Services' },
        ],
    },
    {
        id: 'settings', label: 'Settings', Icon: SlidersHorizontal, items: [
            { path: '/profile-options', Icon: SlidersHorizontal, label: 'Profile Options' },
            { path: '/app-links', Icon: Smartphone, label: 'App Downloads' },
            { path: '/home-stats', Icon: BarChart3, label: 'Home Stats' },
            { path: '/backup', Icon: DatabaseBackup, label: 'Backup' },
            { path: '/my-account', Icon: UserCog, label: 'My Account' },
        ],
    },
];

export const DASHBOARD_ITEM = { path: '/dashboard', Icon: LayoutDashboard, label: 'Dashboard' };

// Flat list for the command palette — Dashboard first, then every grouped
// item, each tagged with its group label so results can show "Users & Access ▸ Profiles".
export const NAV_FLAT = [
    { ...DASHBOARD_ITEM, group: null },
    ...NAV_GROUPS.flatMap(g => g.items.map(item => ({ ...item, group: g.label }))),
];
